import { render, staticRenderFns } from "./babelEdit.vue?vue&type=template&id=21486f3c&scoped=true"
import script from "./babelEdit.vue?vue&type=script&lang=js"
export * from "./babelEdit.vue?vue&type=script&lang=js"
import style0 from "./babelEdit.vue?vue&type=style&index=0&id=21486f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21486f3c",
  null
  
)

export default component.exports